import { ResponsiveContainer, PieChart, Pie, LabelList, Cell, Tooltip, Legend, Label } from "recharts";

const colors = ["#9cc177", "#a989c5", "#509ee3", "#f9d45c", "#F1B556", "#A6E7F3", "#509ee3"];

export default ({ data }) => {
  return (
    <div className="chart-container">
      <ResponsiveContainer>
        <PieChart>
          <Tooltip />
          <Legend />

          <Pie data={data} nameKey="weekday" dataKey="count" label={i => i.total} labelLine={false}>
            {data.map((entry, index) => <Cell key={`cell-${index}`} fill={colors[index]} />)}
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      <style jsx>{`
        .chart-container {
          width: 100%;
          height: 400px;
        }
      `}</style>
    </div>
  );
};



// WEBPACK FOOTER //
// components/stats/PerWeekdayStats.js